import { Content } from '../../../models/content/types';
import FeedHeader, { FeedHeaderProps, FeedViewAllFooter } from './feed-header';

import './content-layouts.scss';
import { FeedCardWithData } from '../../content/solar-feed-card/solar-feed-card';
import useScreenSize from '../../../common/use-screen-size';
import useFeatureFlag from '../../../common/use-feature-flag';
import { Feature } from '../../../models/features/features';
import { MobileHorizontalFeedCards } from './horizontal-scroll-row';

type ContentLayoutRow = FeedHeaderProps & {
  contents: Content[];
  description?: string;
  feedUrl: string;
  viewAllText: string;
  isFetching: boolean;
  minLength: number;
  isTopic: boolean;
};

const ContentLayoutRow = ({
  id,
  title,
  description,
  viewAllText,
  viewAllContext,
  feedUrl,
  isFetching,
  minLength,
  contents,
  analyticsData,
  isTopic = false,
}: ContentLayoutRow) => {
  const { isMobile } = useScreenSize();
  const mobileWebParity = useFeatureFlag(
    Feature.CUSTOM_HOMEPAGE_MOBILE_WEB_PARITY
  );

  const MAX_ITEMS = 3;
  const displayedContents = contents.slice(0, MAX_ITEMS);

  if (!isFetching && displayedContents.length < minLength) return null;

  // Note: Placeholder not implimented when fetching

  return (
    <>
      <FeedHeader
        id={id}
        title={title}
        description={description}
        viewAllLink={feedUrl}
        viewAllText={viewAllText}
        viewAllContext={viewAllContext}
        isTopic={isTopic}
        analyticsData={analyticsData}
        isMobileHorizontal={isMobile && !!mobileWebParity}
      />
      {isMobile && mobileWebParity ? (
        <>
          <MobileHorizontalFeedCards
            contents={contents}
            analyticsData={analyticsData}
            title={title}
          />
          {feedUrl && (
            <FeedViewAllFooter
              viewAllLink={feedUrl}
              viewAllText={viewAllText}
              viewAllContext={viewAllContext}
              isTopic={isTopic}
              analyticsData={analyticsData}
            />
          )}
        </>
      ) : (
        <div className={'content-layout__row'}>
          {displayedContents.map((content) => (
            <div className={'content-layout__row-card'} key={content.id}>
              <FeedCardWithData
                content={content}
                analyticsData={analyticsData}
                compact
                fullHeight
                layout="vertical"
                titleHeadingLevel={2}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ContentLayoutRow;
